@let input = data().searchInput;
@if (input) {
  <div class="searchbar">
    <gc-input-field
      [placeholder]="
        input.placeholder ?? 'tabletoolBar.searchPlaceholder' | translate
      "
      [icon]="'magnifyingGlass'"
      [value]="input.value"
      (changed)="onSearchInputChanged($event)"
    />
  </div>
}

@let picker = data().pageSizePicker;
@if (picker) {
  <app-page-size-picker
    [labelText]="picker.label ?? 'tabletoolBar.itemsPerPage'"
    [allowAll]="picker.allowAll"
    [pageSizeOptions]="picker.itemsPerPageOptions ?? []"
    [startIndex]="startIndex()"
    (selectedSize)="onItemsPerPageSelected($event)"
  />
}
